// var shortCutImg = 'https://statich5clover.happyelements.com/clover-web.png';
// var shareImg = 'https://statich5clover.happyelements.com/clover-web-200.png';
var shortCutImg = 'https://statich5clover.happyelements.com/resource/share/bg/bg_1.jpg';
var shareImg = 'https://statich5clover.happyelements.com/resource/clover-web-200x200-or8.png';
var desc = '全新爆爽消消乐来袭，和我一起闯关吧！不用下载就能玩';
var title = '海滨消消乐';

const SnsMini = require("./SnsMini")

let sns = xClass("snsQQlightgame", SnsMini)

sns.prototype.ctor = function() {
    SnsMini.prototype.ctor.call(this);
    this._adDcName = 'qq_video_ad';
}

sns.prototype._packShareParam = function () {
    let param = {
        onShare: ()=> { 
            let textConfig = TextsManager.getInstance().getRandomTexts('default')
            let shareInfo = {
                    title: textConfig.content,
                    imageUrl: textConfig.bg,
                    query: this.getShareLinkStr({
                        textId: textConfig.textId
                    })
                }
            return shareInfo
        }
    }
    return param;    
}

/**
 * 转译广告位
 */
sns.prototype._translateAdPos = function(adPos = "FailAdd1Step", useDefaultId = false) {
    return 'b40262cdbab6dbb7745dc48bc7085628';
}

sns.prototype.getOpenKey = function (cb) {
    var self = this

    function showLoginFailModal(reason, log) {
        reason = reason || '登录失败请重试'
        sendLog(log)
        mini.showModal({
            title: reason,
            showCancel: false,
            success: function (res) {
            }
        })
    }

    let needCreateUserInfoBtn = false
    function getUserInfo(){
        function onLoginSuccess(code, openid, sessionid){
            //判断是否授权
            mini.getSetting(
                {
                    success:function(res){
                        cc.log(["####getSetting: "], res.authSetting, res.authSetting["scope.userInfo"])
                        if (res.authSetting != null && !res.authSetting["scope.userInfo"]){
                            needCreateUserInfoBtn = true
                        }
                        //needCreateUserInfoBtn = true
                        if (needCreateUserInfoBtn && !self.userInfoBtn){
                            if (code){
                                cb({
                                    code:code,
                                    avatarUrl:'https://ff.happyelements.com/xclover/clover-web@100.png'
                                })
                            }else{
                                cb({
                                    h5game_openid:openid,
                                    h5sdk_sessionid:sessionid,
                                })
                            }
                        }else{
                            console.log("[####]get user info directly")
                            mini.getUserInfo({
                                withCredentials:true,
                                success:function(data){
                                    //cc.log("[####]getUserInfo success", data, code)
                                    //console.log("[####]on getUserInfo success:"+data.signature+" encry:"+data.encryptedData+" iv:"+data.iv)
                                    if (code){
                                        cb({
                                            rawData:data.rawData,
                                            signature:data.signature,
                                            encryptedData:data.encryptedData,
                                            iv:data.iv,
                                            code:code
                                        })
                                    }else{
                                        cb({
                                            h5game_openid:openid,
                                            h5sdk_sessionid:sessionid,
                                            rawData:data.rawData,
                                            signature:data.signature,
                                            encryptedData:data.encryptedData,
                                            iv:data.iv
                                        })
                                    }
                                },
                                fail:function(){
                                    console.log("[####]get user info failed")
                                    showLoginFailModal(null, "getUserInfo fail")
                                }
                            })
                        }
                    },
                    fail:function(){
                        console.log("getSetting failed")
                        showLoginFailModal(null, "getSetting fail")
                    }
                }
            )
        }

        //查看本地是否有登陆态
        let openid = cc.UserDefault.getInstance().getStringForKey("h5game_openid")
        //没有先登陆
        if (!openid || openid.length <= 1 || true)
        {
            console.log("[####]no openid login")
            mini.login({
                success:function(res){
                    if (res.code){
                        onLoginSuccess(res.code)
                    }else{
                        console.log("[####]qq login failed no res.code")
                    }
                },
                fail:function(){
                    console.log("[####]qq login failed")
                }
            })
        }
        //有登陆态验证是否过期
        else{
            mini.checkSession({
                success() {
                    console.log("[####]session is validate")
                    onLoginSuccess(
                        null,
                        cc.UserDefault.getInstance().getStringForKey("h5game_openid"),
                        cc.UserDefault.getInstance().getStringForKey("h5sdk_sessionid")
                        )
                },
                fail() {
                    console.log("[####]session is invalidate relogin")
                    mini.login({
                        success:function(res){
                            if (res.code){
                                onLoginSuccess(res.code)
                            }else{
                                console.log("[####]qq login failed no res.code")
                            }
                        },
                        fail:function(){
                            console.log("[####]qq login failed")
                        }
                    })
                }
              })
        }
    }

    getUserInfo()

    return
}
sns.prototype.checkAuthorizeWithUserBtn =  function (agreeCb, denyCb){
    
    var self = this
    console.log("!!!!qq check autiorize with user btn")
    function sendLog(log) {
        let systemInfo = mini.getSystemInfoSync()
        log += " sdkVersion: " + systemInfo.SDKVersion + ", qqVersion: " + systemInfo.version + ", systemInfo: " + JSON.stringify(systemInfo)
        if (window.logCenter) {
            let msg = {
                message: "login fail: " + log
            }
            window.logCenter.log(msg)
        } else {
            cc.error("login fail: " + log)
        }
    }

    function showLoginFailModal(reason, log) {
        reason = reason || '登录失败请重试'
        sendLog(log)
        mini.showModal({
            title: reason,
            showCancel: false,
            success: function (res) {
            }
        })
    }

    function showAuthorizeModal(agreeCb, denyCb) {
        mini.showModal({
            title: '用户未授权',
            content: '为正常使用程序功能，请按点击确定并在授权管理中选中允许访问用户信息',
            showCancel: false,
            success: function (res) {
                if (res.confirm) {
                    mini.openSetting({
                        success: function (res) {
                            if (res.authSetting != null && res.authSetting["scope.userInfo"]){
                                if (agreeCb){
                                    agreeCb()
                                }
                                refreshAuthorize()
                            }else{
                                if (denyCb){
                                    denyCb()
                                }
                            }
                        }
                    })
                }
            }
        })
    }

    let needCreateUserInfoBtn = false
    mini.getSetting(
        {
            success:function(res){
                if (res.authSetting != null && !res.authSetting["scope.userInfo"]){
                    needCreateUserInfoBtn = true
                }
                if (needCreateUserInfoBtn && !self.userInfoBtn){
                    let fs = cc.director.getOpenGLView().getFrameSize()
                    let scale = cc.view.getDevicePixelRatio() * fs.width / cc.winSize.width
                    let btnWidth = 120 * scale
                    let btnHeight = 72 * scale
                    let btnX = (fs.width - btnWidth) / 2
                    let btnY = ((cc.winSize.height - 300) / cc.winSize.height) * fs.height
                    if (!self.sendDc36) {
                        dc4UserLoad(36)
                        self.sendDc36 = true
                    }
                    self.userInfoBtn = mini.createUserInfoButton({
                        type: 'image',
                        image: 'https://statich5clover.happyelements.com/resource/upload/start_game.png',
                        withCredentials:true,
                        style: {
                            left: btnX,
                            top: btnY,
                            width: btnWidth,
                            height: btnHeight
                        }
                    })
                
                    let sdkVer = mini.getSystemInfoSync().SDKVersion
                    sdkVer = sdkVer.replace(/\./g, "")
                    sdkVer = sdkVer.substring(0, 3)
                    console.log("[####get sdkVer "+ sdkVer)
                
                    self.userInfoBtn.onTap(function (data) {
                        //global.hideProgressbar = null
                        if (!self.sendDc41) {
                            dc4UserLoad(41)
                            self.sendDc41 = true
                        }
                        self.userInfoBtn.destroy()
                        self.userInfoBtn = null
                        if(data.signature)
                        {
                            if (agreeCb){
                                agreeCb()
                            }
                            refreshAuthorize()
                        }
                        else if (
                            data.errMsg.includes("deny") || 
                            data.errMsg == "getUserInfo:fail scope unauthorized") {
                            showAuthorizeModal(agreeCb, denyCb)
                        } 
                        else {
                            showLoginFailModal(null, "ontap fail: " + data.errMsg)
                        }
                    })
                }else{
                    if (agreeCb){
                        agreeCb()
                    }
                }

            },
            fail:function(){
                console.warn("get setting failed")
                if (agreeCb){
                    agreeCb()
                }
            }
        }
    )
}
sns.prototype.onLoginFinish = function(openid, sessionid){
    if (openid && sessionid){
        META.user.openid = openid
        META.user.sessionid = sessionid
        cc.UserDefault.getInstance().setStringForKey("h5game_openid", openid)
        cc.UserDefault.getInstance().setStringForKey("h5sdk_sessionid", sessionid)
    }else{
        console.log("[####]login finish failed no openid or sessionid")
    }
}
sns.prototype.openUrl = function () {
    // 微信不能跳转
}

sns.prototype.hideKeyboard = function () {
    // 微信不能跳转
    mini.hideKeyboard()
}

sns.prototype.share = function (textId, platform, title, imageUrl, _link, callback) {
    imageUrl = imageUrl ? imageUrl : shortCutImg
    title = title ? title : "海滨消消乐"
    //分享链接加上textId
    if (textId && _link) {
        _link = _link + '&textId=' + textId;
    }

    let called = false;
    function onShareCallback(isSuccess) {
        if (called)
            return;

        called = true;

        if (isSuccess === true) {
            callback({
                retCode: 0,
                data: {
                    retCode: 2,
                    msg: "分享成功！"
                }
            })
        } else {
            console.error("分享失败");
            callback({
                retCode: 2,
                data: {
                    retCode: 2,
                    msg: "分享未发送！"
                }
            })
        }
    }

    let share = {
        shareInfo: {
            title: title,
            imageUrl: imageUrl,
            query: _link,
            success: () => {
                console.log("分享成功");
                onShareCallback(true);
            },
            fail: (res) => {
                console.log("分享失败", res);
                onShareCallback(false);
            }
        }
    }

    // QQ有时候会没有回调，所以需要onShow做兜底
    function shareOnShow() {
        mini.offShow(shareOnShow);
        setTimeout(() => {
            if (!called)
                onShareCallback(false);

            called = true
            
        }, 2000);
    }
    mini.onShow(shareOnShow);
    
    cc.log("qq share", share)
    console.log("[################]shareInfo.query:"+share.shareInfo.query)
    
    mini.shareAppMessage(share.shareInfo)
}

sns.prototype.popBack = function () {
    window.mini.exitMiniProgram({})
}

sns.prototype.alert = function (content, onClickOk) {
    mini.showModal({
        showCancel: false,
        content: content,
        success: onClickOk
    })
}

/**
 * 
 * @param {*} img      背景 Image path
 * @param {*} info 
 *                     {
 *                         avatar: avatar path
 *                         avatar2: avatar2 path
 *                         nickname: nickname
 *                         sytle: font 的 css 样式, eg: '48px serif'
 *                         avatarPos: {x:100, y:100}
 *                         nicknamePos: {x:100, y:100}
 *                         radius: 头像半径
 *                     }
 * @param {*} callback 
 */
sns.prototype.drawDataToImg = function (bgpath, info, callback) {

    let oldCallback = callback
    let called = false
    callback = function (path) {
        if (!called) {
            oldCallback && oldCallback(path)
            called = true
        }
    }

    // 如果没有参数直接返回
    if (!info) {
        setTimeout(() => {
            callback && callback(cc.loader.getUrl(cc.loader.resPath, bgpath))
        }, 0);
        return
    }

    let time = 1
    let avatarImg = null
    let avatarImgFail = null
    let radius = info.radius || 100 / 2
    if (info.avatar) {
        time ++
        avatarImg = mini.createImage()
    }
    if (info.avatarFail) {
        time ++
        avatarImgFail = mini.createImage()
    }
    let mycanvas = mini.createCanvas()
    let context = mycanvas.getContext("2d")
    let loadCallback = timeLimitCallbackFunc(onLoadingComplete, time)
    let img = mini.createImage()

    let fillStyle = info.fillSytle || "white"

    function onLoadingComplete() {

        mycanvas.width = img.width
        mycanvas.height = img.height

        // 背景
        context.drawImage(img, 0, 0)

        // 头像
        if (info.avatar) {
            context.beginPath()
            context.arc(info.avatarPos.x + radius, info.avatarPos.y + radius, radius, 0, 2 * Math.PI)
            context.closePath()
            context.save()
            context.clip()
            context.drawImage(avatarImg, info.avatarPos.x, info.avatarPos.y, radius * 2, radius * 2) // 头像
            context.restore()
        }

        // 失败者头像
        if (info.avatarFail) {
            context.beginPath()
            let failRadius = info.avatarFailRaidus || radius
            context.arc(info.avatarFailPos.x + failRadius, info.avatarFailPos.y + failRadius, failRadius, 0, 2 * Math.PI)
            context.closePath()
            context.save()
            context.clip()
            context.drawImage(avatarImgFail, info.avatarFailPos.x, info.avatarFailPos.y, failRadius * 2, failRadius * 2) // 头像
            context.restore()
        }

        // 名字
        if (info.nickname) {
            context.save()
            context.fillStyle = fillStyle
            context.font = info.style
            context.fillText(info.nickname, info.nicknamePos.x, info.nicknamePos.y)
            context.restore()
        }

         // levelDesc
         if (info.levelDesc) {
            context.save()
            context.fillStyle = fillStyle
            context.font = info.levelStyle
            let width = context.measureText(info.levelDesc).width
            context.fillText(info.levelDesc, (img.width - width) / 2, info.levelDescPos.y)
            context.restore()
        }

         // score
         if (info.score) {
            context.save()
            context.fillStyle = fillStyle
            context.font = info.scoreStyle
            let width = context.measureText(info.score).width
            context.fillText(info.score, (img.width - width) / 2, info.scorePos.y)
            context.restore()
        }

        try {
            let tempFilePath = null
            tempFilePath = mycanvas.toTempFilePathSync({
                x: 0,
                y: 0,
                width: img.width,
                height: img.height,
                destWidth: img.width,
                destHeight: img.height
            })
            callback(tempFilePath)
            if (img) {
                img.src = ""
                img = null
            }
            if (avatarImg) {
                avatarImg.src = ""
                avatarImg = null
            }
            if (avatarImgFail) {
                avatarImgFail.src = ""
                avatarImgFail = null
            }
            mycanvas  = null
            context   = null
        } catch (error) {
            callback(cc.loader.getUrl(cc.loader.resPath, bgpath))
            console.error(error)
        }
    }

    let errorCallback = ()=> {
        callback(cc.loader.getUrl(cc.loader.resPath, bgpath))
    }
    img.src = cc.loader.getUrl(cc.loader.resPath, bgpath)
    img.onload = loadCallback
    img.onerror = errorCallback
    if (avatarImg) {
        avatarImg.src = info.avatar
        avatarImg.onload = loadCallback
        avatarImg.onerror = errorCallback
    }
    if (avatarImgFail) {
        avatarImgFail.src = info.avatarFail
        avatarImgFail.onload = loadCallback
        avatarImgFail.onerror = errorCallback
    }
    
    // setTimeout(() => {
    //     callback(cc.loader.getUrl(cc.loader.resPath, bgpath))
    // }, 10*1000);
}

sns.prototype.allowPvp = function() {
    return true;
}

sns.prototype.showGridAd = function(config){
    console.warn("not support grid ad");
}

/**
 * 获取用户所在省份
 * 不涉及权限判断
 * @param lang 语言 目前只支持中文
 * @param callback(err: object, data: { province, lang })
 * 
 */
sns.prototype.fetchProvince = function(callback, lang = "zh_CN") {
    var location = UserManager.getInstance().location
    if (location) {
        callback && callback(null, {
            country: location.country,
            province: location.province,
            lang: "zh_CN"
        })
    } else {
        callback && callback(res, null); 
    }
    // mini.getUserInfo({
    //     withCredentials: false,
    //     lang: lang,
    //     success: res=> {
    //         console.log("[SnsProxy]", "fetchProvince. mini.getUserInfo success.", JSON.stringify(res));
    //         let userInfo = res && res.userInfo;
    //         if (userInfo) {
    //             let { province, language, country } = userInfo;
    //             callback && callback(null, {
    //                 country,
    //                 province,
    //                 lang: language
    //             })
    //         } else {
    //             callback && callback(null, {
    //                 country: "",
    //                 province: "",
    //                 lang: lang
    //             })
    //         }
    //     },
    //     fail: res=> {
    //         callback && callback(res, null); 
    //     }
    // });
}

/**
 * 处理平台会错信息
 * 用于上传错误日志等
 * 不可面向用户展示
 * @param {*} res 
 * @return string
 */
sns.prototype.getErrorMessage = function(res) {
    if (!res)
        return "";
    else if (typeof res === "string")
        return res;
    else {
        try{
            return JSON.stringify(res);
        } catch(e){
            return res.errMsg || ""
        }
    }
}
/**
 * 显示插屏广告用
 */
sns.prototype.setNeedShowInterstitialAdName = function(name, flag) {
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    this.needShowInterstitialAdName[name] = flag;
}

sns.prototype.getNeedShowInterstitialAdName = function(name) {
    cc.log(this.needShowInterstitialAdName)
    if (!this.needShowInterstitialAdName){
        this.needShowInterstitialAdName = [];
    }
    return this.needShowInterstitialAdName[name];
}
module.exports = sns